// extracted by mini-css-extract-plugin
export default {"input":"aF71P","noCross":"bF71P","wrapper":"cF71P","external":"dF71P","autoCompletePlaceholder":"eF71P","inputCross":"fF71P","crossButton":"gF71P","inputWrapper":"hF71P"};